export const Application = {
  Base: 'Base',
};
